export const UPDATE_PINNED_LISTINGS = 'UPDATE_PINNED_LISTINGS';
export const SET_UPDATING_LISTING_ID = 'SET_UPDATING_LISTING_ID';
export const CLEARING_LISTINGS = 'CLEARING_LISTINGS';
export const UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS';
export const REORDER_LISTINGS = 'REORDER_LISTINGS';
export const UPDATE_SEARCH_TEXT = 'UPDATE_SEARCH_TEXT';

import * as api from './api';

export function pinListing({ id }) {
  return (dispatch, getState) => {
    const { updatePath } = getState().module;
    dispatch({ type: SET_UPDATING_LISTING_ID, payload: { id } });
    return api.pinListing({ id, updatePath }).then((pinnedListings) => {
      dispatch({
        type: UPDATE_PINNED_LISTINGS,
        payload: { pinnedListings }
      });
    });
  };
}

export function unpinListing({ id }) {
  return (dispatch, getState) => {
    dispatch({ type: SET_UPDATING_LISTING_ID, payload: { id } });
    const { updatePath } = getState().module;
    return api.unpinListing({ id, updatePath }).then((pinnedListings) => {
      dispatch({
        type: UPDATE_PINNED_LISTINGS,
        payload: { pinnedListings }
      });
    });
  };
}

export function clearListings(e) {
  if (e.preventDefault) e.preventDefault();

  return (dispatch, getState) => {
    dispatch({ type: CLEARING_LISTINGS });
    const { updatePath } = getState().module;
    const ids = getState().pinnedListings.map(l => l.id);
    return api.unpinListings({ ids, updatePath }).then((pinnedListings) => {
      dispatch({
        type: UPDATE_PINNED_LISTINGS,
        payload: { pinnedListings }
      });
    });
  };
}

export function searchListings({ searchText }) {
  return (dispatch, getState) => {
    const { searchPath } = getState().module;
    return api.searchListings({ searchText, searchPath }).then((data) => {
      dispatch({
        type: UPDATE_SEARCH_RESULTS,
        payload: data.inventory ?? []
      });
    });
  };
}

export function localReorder(dragIndex, hoverIndex) {
  return (dispatch) => {
    dispatch({
      type: REORDER_LISTINGS,
      payload: { dragIndex, hoverIndex }
    });
  };
}

export function setSearchText(searchText) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_SEARCH_TEXT,
      payload: { searchText }
    });
  };
}

export function handleSort(e) {
  if (e.preventDefault) e.preventDefault();
  const key = e.target.getAttribute('name');
  return (dispatch, getState) => {
    dispatch({ type: CLEARING_LISTINGS });
    dispatch({ type: REORDER_LISTINGS, payload: { key } });
    const { pinnedListings, module } = getState();

    return api.reorderListings({ pinnedListings, updatePath: module.updatePath }).then((pinnedListings) => {
      dispatch({
        type: UPDATE_PINNED_LISTINGS,
        payload: { pinnedListings }
      });
    });
  };
}

export function saveListingOrder() {
  return (dispatch, getState) => {
    dispatch({ type: CLEARING_LISTINGS });
    const { pinnedListings, module } = getState();

    return api.reorderListings({ pinnedListings, updatePath: module.updatePath }).then((pinnedListings) => {
      dispatch({
        type: UPDATE_PINNED_LISTINGS,
        payload: { pinnedListings }
      });
    });
  };
}
